import React, {useState} from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {Link, useHistory, useLocation, useRouteMatch} from 'react-router-dom'

// import SearchIcon from '@material-ui/icons/Search'
import MyProjectIcon from '@material-ui/icons/ArtTrack'
import LogoutIcon from '@material-ui/icons/ExitToApp'

import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import MuiAppBar from '@material-ui/core/AppBar'
import MuiToolbar from '@material-ui/core/Toolbar'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import CreateProjectIcon from '@material-ui/icons/PostAdd'
// import Tooltip from '@material-ui/core/Tooltip'
import {Avatar, ListItemIcon, ListItemText, List} from '@material-ui/core'

import logo from '../logo.svg'

import {useAuth} from '../helpers/authContext'
import useFetchMyProject from '../helpers/hooks/useFetchMyProject'
import useFetchPublicDetails from '../helpers/hooks/useFetchPublicDetails'

import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline'

import {makeStyles} from '@material-ui/core/styles'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import useFetchILabProject from '../helpers/hooks/useFetchILabProject'
import Divider from '@material-ui/core/Divider'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const AppBar = styled(MuiAppBar)`
	&.MuiAppBar-colorPrimary {
		background-color: white;
		color: black;
	}
`
const Toolbar = styled(MuiToolbar)`
	display: flex;
	justify-content: space-between;

	a,
	a:hover,
	a:visited {
		text-decoration: none;
		color: initial;
	}
`
const ContainerStart = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-grow: 1;
`

const NavContainer = styled.div`
	display: inline-flex;
	margin: 0px 10px;
	cursor: pointer;
`
const NavItem = styled.div`
	font-weight: ${props => (props.active ? '700' : 'normal')};
	color: ${props => (props.active ? '#0ec0e2' : 'inherit')};
	&:hover {
		color: #00d5ffff;
	}
`
const ContainerEnd = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-grow: 1;
	flex-direction: row-reverse;
	.phoneNav {
		@media (max-width: 880px) {
			display: none;
		}
	}
`

// const SearchButton = styled(Button).attrs(() => ({
// 	variant: 'outlined',
// 	fullWidth: true,
// }))`
// 	&.MuiButton-root {
// 		margin: 0 16px;
// 		border-radius: 12px;

// 		@media (max-width: 880px) {
// 			margin: 0;
// 		}
// 	}
// `
const HomeLink = styled(Link)`
	.app-title {
		@media (max-width: 880px) {
			display: none;
		}
	}
	display: flex;
	align-items: center;
	img.logo {
		height: 32px;
		padding: 8px;
	}
`

const UserButtonIcon = styled(Avatar)`
	&.MuiAvatar-root {
		height: 38px;
		width: 38px;
	}
`
const CreateProjectButton = () => {
	return (
		<Button
			component={Link}
			to="/new"
			id="create-project"
			variant="contained"
			className="new-button"
			startIcon={
				<IconButton
					size="small"
					disableRipple
					disableFocusRipple
					style={{color: 'white', background: 'transparent'}}
				>
					<CreateProjectIcon />
				</IconButton>
			}
		>
			Create Project
		</Button>
	)
}

const Header = ({RightItems}) => {
	const isSmallScreen = useMediaQuery('(min-width:880px)')
	const {logout} = useAuth()
	const [menuAnchor, setMenuAnchor] = useState(null)
	// const isSearchPage = useRouteMatch('/search')
	const isCreatePage = useRouteMatch(['/edit', '/new', '/create-project'])

	const handleClick = event => {
		setMenuAnchor(event.currentTarget)
	}

	const handleClose = () => {
		setMenuAnchor(null)
	}

	const publicDetailsQuery = useFetchPublicDetails()

	const email = publicDetailsQuery.isSuccess
		? publicDetailsQuery.data.email
		: null

	const singleProjectQuery = useFetchMyProject(email)

	let pictureURL = null,
		displayName = null
	if (publicDetailsQuery.isSuccess) {
		pictureURL = publicDetailsQuery.data.publicDetails.pictureURL
		displayName = publicDetailsQuery.data.publicDetails.displayName
	}

	const useStyles = makeStyles({
		list: {
			width: 250,
			padding: '5px',
		},
	})

	const classes = useStyles()
	const [open, setOpen] = React.useState(false)

	const toggleDrawer = open => event => {
		if (
			event &&
			event.type === 'keydown' &&
			(event.key === 'Tab' || event.key === 'Shift')
		) {
			return
		}
		setOpen(open)
	}
	const myProjectQuery = useFetchMyProject(email)
	const myProjectsList = myProjectQuery.data?.hits
	let showMyProjects = myProjectsList?.length > 0

	const iLabProjectsQuery = useFetchILabProject()
	const iLabProjectsList = iLabProjectsQuery.data?.hits
	// let showILabProjects = iLabProjectsList?.length > 0

	const history = useHistory()
	const location = useLocation()

	if (location.pathname === '/login') {
		return null
	}
	const pages = [
		{label: 'About BTCP', path: '/'},
		{label: 'Explore Projects', path: '/search'},
		{label: 'Explore Resources', path: '/resources'},
		...(showMyProjects
			? [{label: 'My Projects', path: '/myprojects'}]
			: []),
		// ...(showILabProjects
		// 	? [{label: 'iLab Projects', path: '/ilabprojects'}]
		// 	: []),
	]

	const handleListItemClick = path => {
		history.push(path)
	}

	const list = () => (
		<div
			className={classes.list}
			role="presentation"
			onClick={toggleDrawer(false)}
			onKeyDown={toggleDrawer(false)}
		>
			<IconButton color="inherit" onClick={handleClick}>
				<UserButtonIcon src={pictureURL} alt={displayName}>
					{displayName?.charAt(0)}
				</UserButtonIcon>
				<span style={{marginLeft: '10px', fontSize: '1.1rem'}}>
					Profile
				</span>
			</IconButton>
			<Divider />

			<Menu
				id="simple-menu"
				anchorEl={menuAnchor}
				keepMounted
				open={Boolean(menuAnchor)}
				onClose={handleClose}
			>
				{singleProjectQuery.isSuccess &&
				singleProjectQuery.data.hits.length > 0
					? singleProjectQuery.data.hits.map(hit => (
							<MenuItem
								component={Link}
								to={`/project/${hit.projectId}`}
								key={hit.projectId}
							>
								<ListItemIcon>
									<MyProjectIcon />{' '}
								</ListItemIcon>
								<ListItemText
									primary="My Project"
									secondary={hit.projectName}
								/>
							</MenuItem>
					  ))
					: null}
				<MenuItem onClick={logout}>
					<ListItemIcon>
						<LogoutIcon />
					</ListItemIcon>
					<ListItemText primary="Logout" />
				</MenuItem>
			</Menu>

			<List>
				{pages.map((page, index) => (
					<MenuItem
						key={index}
						selected={location.pathname === page.path}
						onClick={() => handleListItemClick(page.path)}
					>
						<ListItemText primary={page.label} />
					</MenuItem>
				))}
			</List>
		</div>
	)

	return (
		<>
			<AppBar position="sticky">
				<Toolbar>
					<ContainerStart>
						<HomeLink to="/search" id="BTCP-logo">
							<img className="logo" src={logo} alt="" />
							<Typography variant="h6" className="app-title">
								Be The Change
							</Typography>
						</HomeLink>
					</ContainerStart>
					{isSmallScreen &&
						pages.map((page, index) => (
							<NavContainer
								key={index}
								onClick={() => handleListItemClick(page.path)}
							>
								<NavItem
									active={location.pathname === page.path}
								>
									{page.label}
								</NavItem>
							</NavContainer>
						))}
					<ContainerEnd>
						{!isSmallScreen && (
							<ViewHeadlineIcon
								id="phoneProfile"
								fontSize="large"
								onClick={toggleDrawer(true)}
							/>
						)}
						<IconButton
							className="phoneNav"
							color="inherit"
							onClick={handleClick}
						>
							<UserButtonIcon
								id="profile"
								src={pictureURL}
								alt={displayName}
							>
								{displayName?.charAt(0)}
							</UserButtonIcon>
						</IconButton>
						{!isCreatePage && <CreateProjectButton />}
						<Menu
							anchorEl={menuAnchor}
							keepMounted
							open={Boolean(menuAnchor)}
							onClose={handleClose}
						>
							{singleProjectQuery.isSuccess &&
							singleProjectQuery.data.hits.length > 0
								? singleProjectQuery.data.hits.map(hit => (
										<MenuItem
											component={Link}
											to={`/project/${hit.projectId}`}
											key={hit.projectId}
										>
											<ListItemIcon>
												<MyProjectIcon />{' '}
											</ListItemIcon>
											<ListItemText
												primary="My Project"
												secondary={hit.projectName}
											/>
										</MenuItem>
								  ))
								: null}
							<MenuItem onClick={logout}>
								<ListItemIcon>
									<LogoutIcon />
								</ListItemIcon>
								<ListItemText primary="Logout" />
							</MenuItem>
						</Menu>

						{RightItems && <RightItems />}
						{/* {!isSearchPage && (
							<SearchButton
								startIcon={<SearchIcon />}
								component={Link}
								to="/search"
							>
								Search Projects
							</SearchButton>
						)} */}
					</ContainerEnd>
				</Toolbar>
			</AppBar>
			<SwipeableDrawer
				anchor="right"
				open={open}
				onClose={toggleDrawer(false)}
				onOpen={toggleDrawer(true)}
			>
				{list()}
			</SwipeableDrawer>
		</>
	)
}

Header.propTypes = {
	RightItems: PropTypes.element,
}

export default Header
